<section class="section is-medium contact-page__headline" *ngIf="contactPageContent && show">
	<div class="container is-fluid">
		<div class="contact-page__headline-content"
			[innerHTML]="returnHtmlFromRichText(contactPageContent.fields.headline)">
		</div>
	</div>
</section>
<section class="section contact-page__subheading" *ngIf="contactPageContent && show">
	<div class="container is-fluid">
		<div class="contact-page__subheading-content"
			[innerHTML]="returnHtmlFromRichText(contactPageContent.fields.subheading)"></div>
	</div>
</section>
<section class="section" *ngIf="contactPageContent && show">
	<div class="container is-fluid">
		<div class="contact-page__newbiz">
			<h3>{{contactPageContent.fields.newBusinessHeading}}</h3>
			<a class="contact-link" href="mailto:{{contactPageContent.fields.newBusinessEmail}}" target="_
		">{{contactPageContent.fields.newBusinessEmail}}</a>
		</div>
	</div>
</section>
<section class="section" *ngIf="contactPageContent && show">
	<div class="container is-fluid">
		<div class="contact-page__job">
			<h3>{{contactPageContent.fields.jobHeading}}</h3>
			<a class="contact-link" href="mailto:{{contactPageContent.fields.newBusinessEmail}}" target="_
		">{{contactPageContent.fields.jobEmail}}</a>
			<p class="contact-page__job-description">{{contactPageContent.fields.jobDescription}}</p>
		</div>
		<ul class="contact-page__jobs" *ngIf="contactPageContent.fields.showJobsSection === true">
			<li *ngFor="let j of contactPageContent.fields.jobs"><a href="{{j.fields.link}}"
					target="_blank">{{j.fields.title}}</a></li>
		</ul>
	</div>
</section>
<section class="section" *ngIf="contactPageContent && show">
	<div class="container is-fluid">
		<div class="contact-page__general">
			<h3>{{contactPageContent.fields.generalContactHeading}}</h3>
			<a class="contact-link" href="mailto:{{contactPageContent.fields.generalContactEmail}}" target="_
		">{{contactPageContent.fields.generalContactEmail}}</a>
		</div>
	</div>
</section>
